import {Injectable} from '@angular/core';
import {CanDeactivate, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {destroyJournal} from '../_actions/journal.actions';

@Injectable({
	providedIn: 'root'
})
export class JournalDestroyGuard implements CanDeactivate<any> {
	constructor(private store: Store) {}
	canDeactivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		this.store.dispatch(destroyJournal());
		return true;
	}
}
